import { useState } from "react";
import { ShieldWarning, Eye } from "@phosphor-icons/react";
import CheckinOverrides from "./CheckinOverrides";
import ImpersonationLog from "./ImpersonationLog";

const TABS = [
  ["overrides", "Check-in Overrides", ShieldWarning],
  ["viewas", "View-as Log", Eye],
];

export default function OversightPanel() {
  const [tab, setTab] = useState("overrides");
  return (
    <div className="space-y-6" data-testid="oversight-panel">
      <div className="flex gap-1.5" data-testid="oversight-tabs">
        {TABS.map(([v, lbl, Icon]) => (
          <button key={v} data-testid={`oversight-tab-${v}`} onClick={() => setTab(v)}
            className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-[5px] text-sm font-medium border transition-colors ${tab === v ? "bg-[#4A0000] text-white border-[#4A0000]" : "bg-white text-[#5C5A58] border-[#E9DDC6] hover:border-[#4A0000]/40"}`}>
            <Icon size={16} weight={tab === v ? "fill" : "duotone"} /> {lbl}
          </button>
        ))}
      </div>
      {tab === "overrides" ? <CheckinOverrides /> : <ImpersonationLog />}
    </div>
  );
}
